<template>
  <div
    id="not-found"
    class="mt-3 container">
    <div class="row">
      <div class="col">
        <h3 id="not-found">
          The content you are looking for could not be found.
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'not-found',
  data() {
    return {
      testa: 500,
      testb: 500,
      testc: 0.0655,
    };
  },
};
</script>

<style lang="scss"></style>
